var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Welcome to Jumble / Target Time by Auspac Media")]),_c('h3',[_vm._v("This is a holding page only.")]),_c('p',[_vm._v("Please request a link from Auspac Media to access the game.")])])
}]

export { render, staticRenderFns }